<app-menu>
    <div class="grid-header">
        <div class="grid-title">Trip Print Bill of Lading/Labels</div>
      </div>
      <mat-card>
        <mat-card-content>
          <div [formGroup]="searchCarrier" style="display: flex ; justify-content: flex-start; gap: 40px;">
            <span style="flex-basis: 22%;">
              <mat-form-field style="width: 100%;">
                <mat-label>Carrier Name</mat-label>
                <mat-select formControlName="carrier_name" (selectionChange)="carrierChange($event)" required>
                  <mat-option *ngFor="let type of listOfCarrier" [value]="type">{{type}}</mat-option>
                </mat-select>
              </mat-form-field>
            </span>
          </div>
          <div style="width: 20%; display: flex; justify-content: flex-start; gap: 20px;">
            <button (click)="search()" mat-raised-button color="primary" style="background-color: rgb(179, 24, 4);"><i class="fa-solid fa-magnifying-glass"></i><span
                style="padding: 10px 5px;"></span>Search</button>
            <button (click)="resetSearch()" mat-raised-button><i class="fa-solid fa-xmark"></i><span
                style="padding: 10px 5px;"></span>Reset</button>
          </div><br><br>                      
          <div style="align-items: center; justify-content: center;">
                <button *ngIf="isPrintingBillOfLading"  mat-raised-button color="primary"  style="background-color:rgb(6, 24, 116);"  id=submitBtn>
                  <i class="fa fa-spinner fa-spin " > </i>
                  &nbsp;Printing Bill Of Lading&nbsp;
                </button>              
                <button *ngIf="!isPrintingBillOfLading" mat-raised-button color="primary"  style="background-color:rgb(6, 24, 116);" (click)="print_Bill_of_Lading()">
                    <i style="font-size: 15px;"  class="fas fa-print"></i>&nbsp;Print Bill Of Lading
                </button>&nbsp;&nbsp;
                <button *ngIf="isPrintingBOLPalletLabel"  mat-raised-button color="primary"  style="background-color:rgb(6, 24, 116);"  id=submitBtn>
                  <i class="fa fa-spinner fa-spin " > </i>
                  &nbsp;Printing Packing Label&nbsp;
                </button>                  
                <button *ngIf="!isPrintingBOLPalletLabel" mat-raised-button color="primary"  style="background-color:rgb(6, 24, 116);" (click)="print_BOL_Pallet_Label()">
                    <i style="font-size: 15px;"  class="fas fa-truck"></i>&nbsp;Print Packing Label
                </button>&nbsp;&nbsp;
                <button *ngIf="isPrintingPalletLabel"  mat-raised-button color="primary"  style="background-color:rgb(6, 24, 116);"  id=submitBtn>
                  <i class="fa fa-spinner fa-spin " > </i>
                  &nbsp;Printing Pallet Label&nbsp;
                </button>                      
                <button *ngIf="!isPrintingPalletLabel" mat-raised-button color="primary"  style="background-color:rgb(6, 24, 116);" (click)="print_Pallet_Label()">
                    <i style="font-size: 15px;"  class="fas fa-pallet"></i>&nbsp;Print Pallet Label
                </button>&nbsp;&nbsp;
                <button *ngIf="isPrintingTrailerLabel"  mat-raised-button color="primary"  style="background-color:rgb(6, 24, 116);"  id=submitBtn>
                  <i class="fa fa-spinner fa-spin " > </i>
                  &nbsp;Printing Trailer Label&nbsp;
                </button>                
                <button  *ngIf="!isPrintingTrailerLabel" mat-raised-button color="primary"  style="background-color:rgb(6, 24, 116);" (click)="print_Trailer_Label()">
                    <i style="font-size: 15px;"  class="fas fa-trailer"></i>&nbsp;Print Trailer Label
                </button>&nbsp;&nbsp;
                <button *ngIf="isPrintingConsolidateBOL"  mat-raised-button color="primary"  style="background-color:rgb(6, 24, 116);"  id=submitBtn>
                  <i class="fa fa-spinner fa-spin " > </i>
                  &nbsp;Printing Consolidated BOL&nbsp;
                </button>
                <button *ngIf="!isPrintingConsolidateBOL"  mat-raised-button color="primary"  style="background-color:rgb(6, 24, 116);" (click)="print_Consolidated_Bill_of_Lading()">
                  <i style="font-size: 15px;"  class="fas fa-print"></i>&nbsp;Print Consolidated BOL
              </button><br><br>                
            </div>
        </mat-card-content>
      </mat-card>    
    <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-alpine"
        [rowData]="shipments" (gridReady)="onGridReady($event)" [defaultColDef]="defaultColDef"
        #agGrid></ag-grid-angular>
</app-menu>
